<template>
  <div class="ui grid" style="width: 100%">
    <div class="row">
      <h1 class="ui huge header">Active teachers</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row right floated">
      <div class="right floated right aligned size wide column">
        <span>Search for teacher: <input v-model="filter" type="text" /></span>
      </div>
    </div>
    <div class="row">
      <teachers-table
        v-bind:teachers="teachers.users"
        v-bind:actions="actions"
        v-on:rowAction="rowAction"
        show-roll-number="true"
      />
    </div>
    <div class="ui container center aligned">
      <sui-button
        v-if="hasPreviousPage"
        v-on:click="previousPage"
        content="Previous"
      />
      &nbsp;<span>Page: {{ this.paging.page }} of {{ totalPages }}</span
      >&nbsp;
      <sui-button v-if="hasNextPage" v-on:click="nextPage" content="Next" />
    </div>
  </div>
</template>

<script>
import TeachersTable from '@/components/teachers/TeachersTable';
import { mapGetters } from 'vuex';

export default {
  name: 'TeacherSelection',
  components: { TeachersTable },
  computed: {
    hasNextPage() {
      return this.paging.page * this.paging.pageSize < this.teachers.count;
    },
    hasPreviousPage() {
      return this.paging.page > 1;
    },
    totalPages() {
      return Math.ceil(this.teachers.count / this.paging.pageSize);
    },
    ...mapGetters({
      teachers: 'pagedTeachers',
      paging: 'teachersPaging',
    }),
  },
  data() {
    return {
      actions: [],
      filter: '',
    };
  },
  watch: {
    filter(val) {
      this.$store.dispatch('getPagedTeachers', {
        ...this.paging,
        filter: val,
      });
    },
  },
  methods: {
    rowAction(action) {
      switch (action.action) {
        default:
          break;
      }
    },
    nextPage() {
      this.$store.dispatch('getPagedTeachers', {
        ...this.paging,
        page: this.paging.page + 1,
      });
    },
    previousPage() {
      this.$store.dispatch('getPagedTeachers', {
        ...this.paging,
        page: this.paging.page - 1,
      });
    },
  },
  created() {
    this.$store.dispatch('getPagedTeachers', { ...this.paging, filter: '' });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/teachers/TeacherSelection.vue